import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  event = new EventEmitter<string>();

  eventDelete = new EventEmitter<number>();

  constructor(private http: HttpClient) { }

  getAllResult(id,auth_key){
    var headers = new HttpHeaders();
    const options = {headers: headers,withCredintials: false };
    const formData = new FormData();
    formData.append('auth_key', auth_key);
    formData.append('id', id);
    return this.http.post<any>(environment.urlSearch+'?opcion=1', formData, options);
  }

  
  follow(id,auth_key,id_sigue){
    var headers = new HttpHeaders();
    const options = {headers: headers,withCredintials: false };
    const formData = new FormData();
    formData.append('auth_key', auth_key);
    formData.append('id', id);
    formData.append('Sigue[id_seguidor]', id);
    formData.append('Sigue[id_seguido]', id_sigue);
    return this.http.post<any>(environment.urlSearch+'?opcion=2', formData, options);
    
  }

  unfollow(id,auth_key,id_sigue){
    var headers = new HttpHeaders();
    const options = {headers: headers,withCredintials: false };
    const formData = new FormData();
    formData.append('auth_key', auth_key);
    formData.append('id', id);
    formData.append('Sigue[id_seguidor]', id);
    formData.append('Sigue[id_seguido]', id_sigue);
    return this.http.post<any>(environment.urlSearch+'?opcion=5', formData, options);
    
  }
  
  getFollower(id,auth_key){
    var headers = new HttpHeaders();
    const options = {headers: headers,withCredintials: false };
    const formData = new FormData();
    formData.append('auth_key', auth_key);
    formData.append('id', id);
    return this.http.post<any>(environment.urlSearch+'?opcion=4', formData, options);
  }

  getFollowing(id,auth_key){
    var headers = new HttpHeaders();
    const options = {headers: headers,withCredintials: false };
    const formData = new FormData();
    formData.append('auth_key', auth_key);
    formData.append('id', id);
    return this.http.post<any>(environment.urlSearch+'?opcion=3', formData, options);
  }

  sendUserPause(nombre,correo,cargo,nombre_institucion){
    var headers = new HttpHeaders();
    const options = {headers: headers,withCredintials: false };
    const formData = new FormData();
    formData.append('ListaEspera[nombre]', nombre);
    formData.append('ListaEspera[correo]', correo);
    formData.append('ListaEspera[cargo]', cargo);
    formData.append('ListaEspera[nombre_institucion]', nombre_institucion);
    return this.http.post<any>(environment.urlespera, formData, options);
  }
  sendCandidat(nombre,correo,asunto,mensaje,file){
    var headers = new HttpHeaders();
    const options = {headers: headers,withCredintials: false };
    const formData = new FormData();
    formData.append('TrabajaConNosotros[nombre]', nombre);
    formData.append('TrabajaConNosotros[correo]', correo);
    formData.append('TrabajaConNosotros[asunto]', asunto);
    formData.append('TrabajaConNosotros[archivo]', file);
    formData.append('TrabajaConNosotros[mensaje]', mensaje);
    return this.http.post<any>(environment.urlwork, formData, options);
  }

  sendContact(nombre,correo,telefono,mensaje){
    var headers = new HttpHeaders();
    const options = {headers: headers,withCredintials: false };
    const formData = new FormData();
    formData.append('Contacto[nombre]', nombre);
    formData.append('Contacto[correo]', correo);
    formData.append('Contacto[telefono]', telefono);
    formData.append('Contacto[mensaje]', mensaje);
    return this.http.post<any>(environment.urlcontac, formData, options);
  }

}
